import { useState, memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import { SettingsProvider } from '@/contexts/SettingsContext';
import AppBar from '@/components/layout/AppBar';
import Sidebar from '@/components/layout/Sidebar';

/**
 * 主布局组件 - 统一的应用布局
 * 包含侧边栏、顶栏和主内容区
 * 使用 memo 优化性能，避免不必要的重渲染
 */
function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleMenuClick = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <SettingsProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
        <AppBar onMenuClick={handleMenuClick} />
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            minHeight: '100vh',
            bgcolor: 'background.default',
            transition: (theme) =>
              theme.transitions.create(['margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
          }}
        >
          <Toolbar />
          {/* 直接渲染子路由，不添加额外的过渡动画以避免闪烁 */}
          <Outlet />
        </Box>
      </Box>
    </SettingsProvider>
  );
}

// 使用 memo 优化，避免父组件更新时不必要的重渲染
export default memo(MainLayout);
